<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="notification-list-sidebar" position="left" lockedOpen="gt-md">
        <notification-list-sidebar></notification-list-sidebar>
    </fuse-sidebar>

    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                      fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                    <div class="h2 mb-24">{{'Notification data'|translate}}</div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Message template'|translate}}</mat-label>
                            <mat-select formControlName="template" required>
                                <mat-option [value]="template.id" *ngFor="let template of templates.items">
                                    {{template.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{'Message template is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Reason'|translate}}</mat-label>
                            <mat-select formControlName="reason" required>
                                <mat-option [value]="template.id" *ngFor="let template of reasons">
                                    {{template.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{'Reason is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Hours before send'|translate}}</mat-label>
                            <input matInput formControlName="hours" required>
                            <mat-error>{{'Value is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="enabled" fxFlex="100">
                            <mat-label>{{'Enabled'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button type="submit" color="accent">
                                {{'Save'|translate}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
